(function () {
  window.dataLayer = window.dataLayer || [];

  var lastKey = '';
  var lastAt = 0;
  var galleryTouched = false;

  function normalizeSize(value) {
    var text = String(value || '').replace(/\s+/g, '').toLowerCase();
    if (/30/.test(text) && /40/.test(text)) return '30x40';
    if (/60/.test(text) && /80/.test(text)) return '60x80';
    if (/50/.test(text) && /60/.test(text)) return '50x60';
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function variantSize() {
    var match = String(window.location.search || '').match(/[?&]variant=(\d+)/);
    var id = match ? match[1] : '';
    if (id === '45787807907949') return '30x40';
    if (id === '45787807940717') return '50x60';
    if (id === '45787807973485') return '60x80';
    return '';
  }

  function currentSize() {
    var radios = document.querySelectorAll(
      'variant-selects input[type="radio"]:checked, .product-form__input input[type="radio"]:checked'
    );
    for (var i = 0; i < radios.length; i++) {
      var size = normalizeSize(radios[i].value);
      if (size) return size;
    }
    return variantSize();
  }

  function hasPhoto() {
    if (document.body.classList.contains('pupprint-has-photo')) return true;
    var pid = document.querySelector('input[name="properties[Personalization ID]"]');
    return Boolean(pid && String(pid.value || '').trim());
  }

  function variantId() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? String(input.value || '') : '';
  }

  function track(name, params) {
    if (!name) return;
    var payload = {
      event: name,
      size: currentSize(),
      has_photo: hasPhoto(),
      item_name: 'Custom Dog Photo Blanket',
      item_variant: currentSize() || undefined,
      item_id: variantId() || undefined,
    };
    Object.keys(params || {}).forEach(function (key) {
      if (params[key] !== undefined && params[key] !== '') payload[key] = params[key];
    });
    var key = name + ':' + JSON.stringify(payload);
    var now = Date.now();
    if (key === lastKey && now - lastAt < 1200) return;
    lastKey = key;
    lastAt = now;

    window.dataLayer.push(payload);
    if (typeof window.gtag === 'function') {
      var gtagParams = {};
      Object.keys(payload).forEach(function (key) {
        if (key !== 'event') gtagParams[key] = payload[key];
      });
      window.gtag('event', name, gtagParams);
    }
  }

  window.pupprintTrack = track;

  function galleryLabel(node) {
    if (!node || !node.closest) return '';
    var slide = node.closest('.product__media-item, .thumbnail-list__item') || node;
    if (slide.classList.contains('pupprint-pdp-video-slide') || slide.classList.contains('pupprint-pdp-video-thumb')) {
      return 'Video';
    }
    if (slide.classList.contains('pupprint-preview-slide') || slide.classList.contains('pupprint-preview-thumb')) {
      return 'Your photo';
    }
    var labeled = slide.querySelector('[aria-label]');
    if (labeled && labeled.getAttribute('aria-label')) return labeled.getAttribute('aria-label');
    var img = slide.querySelector('img[alt]');
    if (img && img.alt) return img.alt;
    var mockup = String(slide.className || '').match(/pupprint-mockup-(\d+)/);
    var labels = { 439: 'Front', 441: 'Folded', 6408: 'Draped', 6410: 'Lifestyle' };
    if (mockup && labels[mockup[1]]) return labels[mockup[1]];
    return (slide.getAttribute('data-media-id') || '').replace(/^\d+-/, '') || 'Gallery';
  }

  function personalizeSource(target) {
    if (!target || !target.closest) return 'button';
    if (target.closest('.pupprint-sticky')) return 'sticky';
    if (target.closest('.pupprint-header, header-drawer, sticky-header')) return 'header';
    if (target.closest('.pupprint-announce')) return 'banner';
    if (target.closest('.product-form, .product__info-wrapper')) return 'product';
    if (target.closest('a[href$="#add-to-cart"], [name="add"], .product-form__submit')) return 'add_to_cart_gate';
    return 'button';
  }

  function isPersonalizeTrigger(target) {
    if (!target || !target.closest) return null;
    var link = target.closest('a[href*="#personalize"]');
    if (link) return link;
    var button = target.closest('button');
    if (
      button &&
      /upload your dog|personalize|change photo/i.test((button.textContent || '').replace(/\s+/g, ' ').trim())
    ) {
      return button;
    }
    return null;
  }

  function isAddTrigger(target) {
    if (!target || !target.closest) return false;
    return Boolean(
      target.closest('[name="add"], .product-form__submit, shop-pay-button, .shopify-payment-button, a[href$="#add-to-cart"]')
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.isTrusted) return;
      var target = event.target;

      var sizeCard = target.closest && target.closest('.pupprint-size');
      if (sizeCard) {
        var name = sizeCard.querySelector('.pupprint-size__name');
        track('select_size', {
          size: normalizeSize(name ? name.textContent : ''),
          method: 'size_card',
        });
      }

      var thumb = target.closest && target.closest('.thumbnail-list__item button, .thumbnail-list__item');
      if (thumb && target.closest('.thumbnail-list')) {
        galleryTouched = true;
        track('select_gallery', {
          gallery_label: galleryLabel(thumb),
          method: 'thumbnail',
        });
      }

      if (target.closest && target.closest('slider-component [name="previous"], slider-component [name="next"]')) {
        galleryTouched = true;
      }

      var personalize = isPersonalizeTrigger(target);
      if (personalize) {
        track('open_personalize', { method: personalizeSource(personalize) });
      }

      if (isAddTrigger(target) && !hasPhoto()) {
        track('add_to_cart_blocked', { reason: 'no_photo' });
        track('open_personalize', { method: 'add_to_cart_gate' });
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target) return;

      if (target.matches && target.matches('variant-selects input[type="radio"], .product-form__input input[type="radio"]')) {
        if (!event.isTrusted) return;
        track('select_size', {
          size: normalizeSize(target.value),
          method: 'pdp',
        });
        return;
      }

      if (target.matches && target.matches('variant-selects select')) {
        if (!event.isTrusted) return;
        track('select_size', {
          size: normalizeSize(target.value),
          method: 'pdp_dropdown',
        });
        return;
      }

      if (target.type === 'file' && target.files && target.files[0] && !target.__pupprintConverting) {
        var file = target.files[0];
        var name = String(file.name || '').toLowerCase();
        track('upload_photo', {
          file_type: file.type || name.split('.').pop() || 'unknown',
          file_size_kb: Math.round((file.size || 0) / 1024),
          heic: /\.heic$|\.heif$|image\/hei/i.test(file.type + name),
        });
      }
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (event.target && event.target.closest && event.target.closest('media-gallery')) {
        galleryTouched = true;
      }
    },
    true
  );

  document.addEventListener('slideChanged', function (event) {
    if (!galleryTouched) return;
    var slide = event.detail && event.detail.currentElement;
    if (!slide || !slide.closest || !slide.closest('media-gallery')) return;
    track('select_gallery', {
      gallery_label: galleryLabel(slide),
      method: 'swipe',
    });
  });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (!form.matches('[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;
      if (!hasPhoto()) return;
      track('add_to_cart', {
        currency: 'USD',
        method: 'product_form',
      });
    },
    true
  );

  window.addEventListener('message', function (event) {
    if (!event.data) return;
    var type = event.data.type || event.data.event || '';
    if (type === 'PERSONALIZATION_APPLIED') {
      track('apply_personalize', { method: 'printify' });
    }
    if (type === 'CLOSE_PERSONALIZATION_MODAL') {
      track('close_personalize', { applied: hasPhoto() });
    }
  });

  window.addEventListener('hashchange', function () {
    if (window.location.hash === '#personalize') {
      track('open_personalize', { method: 'hash' });
    }
  });

  if (window.location.hash === '#personalize') {
    track('open_personalize', { method: 'hash' });
  }
})();
